import {
  ApplicationConfig,
  ENVIRONMENT_INITIALIZER,
  ErrorHandler,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { getCustomPaginatorIntl } from './shared/utils/custom-paginator-intl';
import { MAT_TABS_CONFIG } from '@angular/material/tabs';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { loaderInterceptor } from './core/interceptors/loader.interceptor';
import { GlobalErrorHandlerService } from './core/services/global-error-handler.service';
import {
  provideAuth,
  type IProvideAuthOptions,
} from '@mbai/multi-tenant-common-auth-ng';
import { environment } from '../environments/environment';
import { PartnerBrandingService } from './core/services/partner-branding.service';

const authOptions: IProvideAuthOptions = {
  base: {
    authApiUrl: environment.userManagementAPI,
    postLoginHomePath: '/',
    keycloak: {
      redirectUri: `${window.location.origin}/auth/callback`,
      authorityBase: environment.oidcConfig.authority,
    },
  },
  tenantDiscovery: {
    apiBaseUrl: environment.userManagementAPI,
    localhost: {
      realm: environment.oidcConfig.localhostRealm,
      clientId: environment.oidcConfig.localhostClientId,
    },
  },
  extraHttpInterceptors: [authInterceptor, loaderInterceptor],
  branding: {
    taglineText: 'Delivering a single source of truth for enterprise data.',
  },
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideAuth(authOptions),
    {
      provide: ENVIRONMENT_INITIALIZER,
      multi: true,
      useFactory: (partnerBranding: PartnerBrandingService) => () => partnerBranding,
      deps: [PartnerBrandingService],
    },
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    provideRouter(routes, withComponentInputBinding()),
    provideAnimationsAsync(),
    {
      provide: MatPaginatorIntl,
      useValue: getCustomPaginatorIntl(),
    },
    { provide: MAT_TABS_CONFIG, useValue: { animationDuration: '0ms' } },
  ],
};
